import { gql } from '@apollo/client/core';

const standardFeatures = {
  STANDARD_FEATURES: gql`
    fragment StandardFeatures on Feature {
      id
      shortname
      code
      categoryCode
    }
  `,
};

export default standardFeatures;
